<template>
  <div>
    <div>
      <b-row v-if="!reviewList.length" class="d-flex justify-content-center pt-5">
        <h1 class="text-center">{{ $t('no_reviews') }}</h1>
      </b-row>
      
      <b-row v-else>
        <b-col v-for="(item, index) in reviewList" :key="index" md="6" lg="4">
          <review-card-item :title="item.user.fullName" :sub-title="item.date.toDate().toLocaleDateString('fi')" :reviews="item.review" />
        </b-col>
      </b-row>

      <div v-if="reviewList.length" class="mx-2 mb-2">
        <b-row>
          <b-col
            cols="12"
            sm="12"
            class="d-flex align-items-center justify-content-end justify-content-sm-end"
          >
            <ul role="menubar" class="pagination mr-5 mb-0 b-pagination pagination-lg">
              <li
                role="presentation"
                :class="['page-item', currentPage > 1 ? '' : 'disabled']"
                :disabled="currentPage === 1"
                @click="onChangePage('prev')"
              >
                <button role="menuitem" type="button" class="page-link">
                  <span class="text-primary">
                    {{ $t('pagination.btn.prev') }}
                  </span>
                </button>
              </li>
              <li role="presentation" class="page-item active">
                <button role="menuitemradio" type="button" class="page-link">
                  {{ currentPage }}
                </button>
              </li>
              <li
                role="presentation"
                :class="['page-item', canLoadMore ? '' : 'disabled']"
                :disabled="!canLoadMore"
                @click="onChangePage('next')"
              >
                <button role="menuitem" type="button" class="page-link">
                  <span class="text-primary">
                    {{ $t('pagination.btn.next') }}
                  </span>
                </button>
              </li>
            </ul>
          </b-col>
        </b-row>
      </div>
    </div>
  </div>
</template>

<script>
import { BRow, BCol } from 'bootstrap-vue'
import { mapState } from 'vuex'
import ToastificationContent from '@hw-ui/components/toastification/ToastificationContent.vue'
import ReviewCardItem from '../shared/ReviewCardItem.vue'

export default {
  components: {
    BRow,
    BCol,

    ReviewCardItem,
  },
  data() {
    return {
      currentUser: null,
      currentPage: 1,
      actionChangePage: '',
      areaId: ''
    }
  },
  computed: {
    ...mapState('appReview', {reviewList: 'reviews', canLoadMore: 'canLoadMore'}),
  },
  watch: {
    actionChangePage(newValue) {
      if (newValue) {
        this.fetchReviewList()
      }
    },
  },
  mounted() {
    this.fetchReviewList()
  },
  methods: {
    fetchReviewList() {
      try {
        this.$store.dispatch('appReview/fetchReviews', { areaId: this.$router.currentRoute.params.id, action: this.actionChangePage })
      } catch (error) {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: this.$t('error_fetch_reviews'),
            icon: 'AlertTriangleIcon',
            variant: 'danger',
          },
        })
      }
    },
    onChangePage(action) {
      if (action === 'prev' && this.currentPage > 1) {
        this.currentPage -= 1
        this.actionChangePage = 'prev'
      }
      if (action === 'next' && this.canLoadMore) {
        this.currentPage += 1
        this.actionChangePage = 'next'
      }
    },
  },
}
</script>
